export default "__VITE_ASSET__45ad00fe__"